var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container homebase-container pt-5 px-0" }, [
    _vm.isLoading
      ? _c("div", [_c("loading-spinner-small")], 1)
      : _c("div", [
          _vm.isErrored
            ? _c("div", { staticClass: "mt-4 alert alert-error" }, [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.CONSTANTS.SERVER_ERROR_MESSAGE) +
                    "\n    "
                )
              ])
            : _c("div", [
                _c(
                  "div",
                  { staticClass: "table-wrapper" },
                  [
                    _c(
                      "vue-good-table",
                      {
                        key: _vm.componentKey,
                        ref: "bookmarksTable",
                        staticClass: "table-word-wrap",
                        attrs: {
                          columns: _vm.columns,
                          rows: _vm.bookmarks,
                          "search-options": _vm.searchOptions,
                          "sort-options": _vm.sortOptions,
                          "pagination-options": {
                            enabled: false
                          },
                          styleClass: "vgt-table striped",
                          "row-style-class": _vm.rowStyleClassFn
                        },
                        on: { "on-sort-change": _vm.onSortChange },
                        scopedSlots: _vm._u([
                          {
                            key: "table-row",
                            fn: function(props) {
                              return [
                                props.column.field === "actions"
                                  ? _c("span", [
                                      _c(
                                        "div",
                                        [
                                          _c("pin-bookmark", {
                                            staticClass: "d-inline-block pr-2",
                                            attrs: {
                                              "bookmark-data": props.row,
                                              "pinning-disabled":
                                                _vm.pinningDisabled,
                                              "success-msg": _vm.getSuccessMessage(
                                                props.row.id
                                              )
                                            },
                                            on: {
                                              bookmarkPinned:
                                                _vm.handleBookmarkPinned,
                                              bookmarkUnpinned:
                                                _vm.handleBookmarkUnpinned
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("AutodeskOneToggleBookmarkPage", {
                                            staticClass: "mr-2 d-inline-block",
                                            attrs: {
                                              bookmarkRowValue: props.row
                                            },
                                            on: {
                                              bookmarkRemoved: function(
                                                $event
                                              ) {
                                                return _vm.triggerBookmarkRemoval(
                                                  props.row
                                                )
                                              },
                                              bookmarkRemovalUndo: function(
                                                $event
                                              ) {
                                                return _vm.cancelBookmarkRemoval(
                                                  props.row
                                                )
                                              }
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ])
                                  : props.column.field == "title"
                                  ? _c("span", [
                                      _c(
                                        "div",
                                        { staticClass: "truncate-title" },
                                        [
                                          _c(
                                            "a",
                                            {
                                              attrs: {
                                                href: props.row.url,
                                                target: _vm.getBookmarkTarget(
                                                  props.row.url
                                                )
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(props.row.title) +
                                                  "\n                "
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ])
                                  : _vm._e()
                              ]
                            }
                          },
                          {
                            key: "table-column",
                            fn: function(props) {
                              return [
                                props.column.label == "Pins"
                                  ? _c("span", [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(_vm.pinsColumnLabel) +
                                          "\n            "
                                      )
                                    ])
                                  : _c("span", [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(props.column.label) +
                                          "\n            "
                                      )
                                    ])
                              ]
                            }
                          }
                        ])
                      },
                      [
                        _c(
                          "div",
                          { attrs: { slot: "emptystate" }, slot: "emptystate" },
                          [
                            _c("div", { staticClass: "emptystate-text" }, [
                              _vm._v("No bookmarks to display")
                            ])
                          ]
                        )
                      ]
                    )
                  ],
                  1
                )
              ])
        ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-beb7133c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-beb7133c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/homebase/bookmarks/BookmarksTable.vue
// module id = null
// module chunks = 